export default "__VITE_ASSET__DnUNH6mv__"